import { useState, useEffect } from "react"
import { AiOutlineDelete, AiOutlineSync, AiOutlineEdit } from "react-icons/ai"
import { toast } from "react-toastify"
import {
    deleteManagerPanel,
    addManagerPanel,
    editManagerPanel,
    getManagerPanelList,
} from "../../services/managerPanelApis"
import MyModal from "../MyModal"
import Input from "../Input"
import Table from "../Table"
import apiHelper from "../../services/apiHelper"
import { API_ROUTES } from "../../utils/constants"

const cols = [
    {
        name: "وضعیت",
        colSpan: 1,
    },
    {
        name: "نام پنل",
        colSpan: 1,
    },
    {
        name: "ایپی پنل",
        colSpan: 1,
    },
    {
        name: "توکن",
        colSpan: 1,
    },
    {
        name: "حداکثر بات",
        colSpan: 1,
    },
    {
        name: "",
        colSpan: 1,
    },
]

const AddPanelModal = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            name: form.get("panel-name"),
            host: form.get("host"),
            token: form.get("token"),
            maxBot: form.get("max-bot"),
        }

        if (user) {
            toast
                .promise(addManagerPanel(data), {
                    pending: "درحال اضافه کردن",
                    success: "اضافه شد",
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        toast.error(err.response.data)
                    }
                    console.error(err)
                })
        }
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-28 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                اضافه پنل
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} height="400px" width="400px">
                <div className="">
                    <form onSubmit={submitHandler} className="m-5">
                        <div className="">
                            <Input type="text" label="نام پنل" name="panel-name" placeholder="نام" required={true} />
                        </div>
                        <div className="">
                            <Input
                                type="text"
                                label="هاست"
                                name="host"
                                placeholder="http://localhost:1111"
                                required={true}
                            />
                        </div>
                        <div>
                            <Input type="text" label="توکن" name="token" placeholder="توکن" required={true} />
                        </div>
                        <div>
                            <Input
                                type="number"
                                label="حداکثر بات"
                                name="max-bot"
                                placeholder="حداکثر تعداد بات"
                                required={true}
                            />
                        </div>
                        <button type="submit" className="mt-5 styled-button success">
                            اضافه کردن پنل
                        </button>
                    </form>
                </div>
            </MyModal>
        </>
    )
}

const EditPanelModal = ({ panel, user }) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)

        const data = {
            panelId: panel.id,
            host: form.get("host"),
            token: form.get("token"),
            maxBot: form.get("max-bot"),
        }

        if (user) {
            toast
                .promise(editManagerPanel(data, user.token), {
                    pending: "درحال ویرایش",
                    success: "ویرایش شد",
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        toast.error(err.response.data)
                    }
                    console.error(err)
                })
        }
    }

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
            >
                <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
            </button>

            <MyModal isOpen={isOpen} toggleModal={toggleModal} height="400px" width="400px">
                <div className="">
                    <form onSubmit={submitHandler} className="m-5">
                        <div className="">
                            <Input
                                type="text"
                                label="نام پنل"
                                name="panel-name"
                                placeholder="نام"
                                defaultValue={panel.name}
                                disabled={true}
                                required={true}
                            />
                        </div>
                        <div className="">
                            <Input
                                type="text"
                                label="هاست"
                                name="host"
                                placeholder="http://localhost:1111"
                                defaultValue={panel.host}
                                required={true}
                            />
                        </div>
                        <div>
                            <Input
                                type="text"
                                label="توکن"
                                name="token"
                                defaultValue={panel.token}
                                placeholder="توکن"
                                required={true}
                            />
                        </div>
                        <div>
                            <Input
                                type="number"
                                label="حداکثر بات"
                                name="max-bot"
                                placeholder="حداکثر تعداد بات"
                                defaultValue={panel.max_bot}
                                required={true}
                            />
                        </div>
                        <button type="submit" className="mt-5 styled-button warning">
                            ویرایش پنل
                        </button>
                    </form>
                </div>
            </MyModal>
        </>
    )
}

const ManagerPanels = ({ user }) => {
    const [panelList, setPanelList] = useState(null)

    const deletePanelHandler = (id) => {
        if (user) {
            toast
                .promise(deleteManagerPanel(id), {
                    pending: "درحال حذف",
                    success: "حذف شد",
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    const updateUi = () => {
        if (user) {
            getManagerPanelList(user.token)
                .then(({ data }) => {
                    data = data.map((p) => {
                        let obj = {
                            name: p.name,
                            status: (
                                <span className={p.status == "online" ? "bg-blur-success" : "bg-blur-danger"}>
                                    {p.status == "online" ? "روشن" : "خاموش"}
                                </span>
                            ),
                            host: p.host,
                            token: p.token.length > 30 ? "...." + p.token.slice(0, 30) : p.token,
                            maximum: `${p.in_use_count}/${p.max_bot}`,
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <EditPanelModal user={user} panel={p} />
                                    <button
                                        onClick={() => deletePanelHandler(p.id)}
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setPanelList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <div className="flex justify-between">
                <AddPanelModal user={user} />
                <button
                    onClick={() =>
                        toast.promise(apiHelper({ method: "get", path: API_ROUTES.SETTINGS.REFRESH_PANELS }), {
                            pending: "درحال رفرش",
                            success: "رفرش شد",
                        })
                    }
                    className="ml-4 px-2 flex gap-2 styled-button warning  mb-3"
                >
                    <AiOutlineSync size="1.3em" />
                    رفرش
                </button>
            </div>
            <Table cols={cols} rows={panelList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default ManagerPanels
